import React, { useState } from 'react';
import Modal from 'react-modal';
import '../LoginModals.css';
import { customStyles, UserFlowModalState } from '../../UserFlow/UserFlowModal';

const initialStates = {
  showModal: true,
  validationFail: true,
};

function GetPasswordSuccessStandalone(props: UserFlowModalState) {
  const [ state, setState ] = useState(initialStates);

  const closeModal = () => {
    setState({
      ...state,
      showModal: false,
    });
    props.closeModal();
  };

  // const userNameVerified = () => {
  //   props.updateVerifiedUser(props.userStatus.userId);
  // };

  const goToIRCTCRegistrationPage = () => {
    props.createAccount();
  };

  const goToResetPasswordPage = () => {
    props.switchModal('forgotPasswordStandalone', props.userStatus);
  };

  const { userStatus: { userId, mobileEntered, email, otpType }, allowClose } =props;
  const { showModal, validationFail } =state;

  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className='loginModals loginModals--v4'
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <p className='textRight makeFlex spaceBetween start modalCloseCont accountSuccess'>
        <span className="font26 latoBlack accountCreatedRound appendRight5 textCenter"><span className="checkmark">  </span></span>
        <span
          className='modalClose railSprite crossIcon'
          onClick={closeModal}>
        </span>
      </p>

      <p className='font20 latoBold blackText appendBottom10 appendTop20'>Password Reset</p>
      {
        otpType === "M"
        ? <p className='font14 lineHeight20 appendBottom40'>You will get an SMS on <b>{mobileEntered}</b> from IRCTC with a new password.</p>
        : <p className='font14 lineHeight20 appendBottom40'>You will get an email on <b>{email}</b> from IRCTC with a new password.</p>
      }


      <div className='end'>

        <p className='makeFlex hrtlCenter font14 darkGreyText paddingT10 appendBottom5'>
          <span>Didn’t receive password?</span>
          {/*<span className="timer">*/}
          {/*  <span className="railSprite timerIcon appendRight5"></span>*/}
          {/*  <span className="whiteText latoBlack"> 00 : 26s</span>*/}
          {/*</span>*/}
        </p>
        <p className='appendBottom20 opactityD6' onClick={goToResetPasswordPage}><a className='font16 latoBold '>Resend OTP</a></p>
        <p className='font14 darkGreyText paddingT20 appendBottom5'>Facing trouble?</p>
        <p><a className='font16 latoBold ' onClick={goToIRCTCRegistrationPage}>Create New Account</a></p>
      </div>
    </Modal>
  );
}
export default GetPasswordSuccessStandalone;
